import {SuccessfulApiResponse} from '@eryxcoop/appyx-comm';

export default class AllowanceFormOptionsResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                customers: [],
                articles: [],
                concepts: [],
                franchise_brands: [],
            },
            errors: [],
        };
    }

    customers() {
        return this.content().customers;
    }

    articles() {
        return this.content().articles;
    }

    concepts() {
        return this.content().concepts;
    }

    franchiseBrands() {
        return this.content().franchise_brands;
    }
}
